import { render, staticRenderFns } from "./product_transfer.vue?vue&type=template&id=5f953003&scoped=true&"
import script from "./product_transfer.vue?vue&type=script&lang=js&"
export * from "./product_transfer.vue?vue&type=script&lang=js&"
import style0 from "./product_transfer.vue?vue&type=style&index=0&id=5f953003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f953003",
  null
  
)

export default component.exports